import { useState } from "react";
import { ApiError, startCheckout, syncBilling } from "../api";
import { btnShu } from "./Cram";

export function SubscribeOffer() {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const subscribe = async () => {
    setBusy(true);
    setError(null);
    try {
      window.location.href = (await startCheckout()).url;
    } catch (e) {
      if (e instanceof ApiError && e.status === 409) {
        await syncBilling().catch(() => null);
        window.location.reload();
        return;
      }
      setError(e instanceof Error ? e.message : String(e));
      setBusy(false);
    }
  };

  return (
    <div>
      <dl className="grid grid-cols-[5rem_1fr] border-2 border-ink bg-sheet text-[12px] leading-relaxed sm:grid-cols-[6.5rem_1fr] [&>div:last-child>*]:border-b-0">
        {(
          [
            ["料金", <><span className="font-mono text-[15px] font-bold text-shu">¥980</span> / 月(税込)・全コレクション使い放題</>],
            ["支払時期", "申込み時に初回を決済。以後、申込日を基準に毎月自動で決済"],
            ["契約期間", "1 か月単位の自動更新"],
            ["解約", "アカウントの「お支払い・解約の管理」からいつでも解約可能。解約後も現在の請求期間の末日まで利用可能。日割り返金なし"],
          ] as const
        ).map(([k, v]) => (
          <div key={k} className="contents">
            <dt className="hatch border-r border-b border-ink px-3 py-2 font-black">{k}</dt>
            <dd className="border-b border-ink px-3 py-2">{v}</dd>
          </div>
        ))}
      </dl>
      <button type="button" onClick={subscribe} disabled={busy} className={`${btnShu} mt-4 w-full sm:w-auto`}>
        {busy ? "移動中…" : "月額 980 円(税込)で申し込む"}
      </button>
      <p className="mt-3 text-[11px] leading-relaxed text-ink-2">
        お支払いは Stripe の決済画面で行います。申込みにより
        <a href="/ja/terms" className="font-bold underline">
          利用規約
        </a>
        ・
        <a href="/ja/tokushoho" className="font-bold underline">
          特定商取引法に基づく表記
        </a>
        に同意したものとみなします。
      </p>
      {error && <p className="mt-2 text-[12px] font-bold text-shu">{error}</p>}
    </div>
  );
}

export function Paywall({ title }: { title?: string }) {
  return (
    <section className="border-2 border-ink bg-sheet px-4 py-5">
      <p className="flex items-center gap-2 text-[14px] font-bold">
        <span className="text-shu">
          <LockIcon />
        </span>
        {title ? `「${title}」は` : "このコレクションは"}使い放題プランで再生できます。
      </p>
      <p className="mt-1 text-[12px] text-ink-2">無料コレクションは契約なしで再生できます。</p>
      <div className="mt-4">
        <SubscribeOffer />
      </div>
    </section>
  );
}

export function LockIcon() {
  return (
    <svg width={11} height={11} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={3} aria-label="locked">
      <rect x="4" y="11" width="16" height="10" />
      <path d="M8 11V7a4 4 0 0 1 8 0v4" />
    </svg>
  );
}
